export default {
    name: "QuickActionsWidget",
    type: "HtmlWidget",
    description: "Shortcuts to common actions in Sonar.",
    roles: ["appUser"],
    widget: {
        title: "Quick Actions",
        size: "small",
        html: `
            <div class="d-grid gap-2">
                <button class="btn btn-primary" data-action="emit" data-event="ui:show-monitor-modal">
                    <i class="bi bi-plus-lg me-2"></i> New Monitor
                </button>
                <button class="btn btn-outline-secondary" data-action="navigate" data-route="/user/routines">
                    <i class="bi bi-arrow-repeat me-2"></i> Manage Routines
                </button>
                <button class="btn btn-outline-secondary" data-action="navigate" data-route="/user/alerts">
                    <i class="bi bi-bell-fill me-2"></i> View Alerts
                </button>
            </div>
        `
    }
};